export enum NOTICES_DEFAULT_FIELDS {}
